import { withMetadata } from '../min/metadata'

import _parse from '../es6/parse'

export function parse() {
	return withMetadata(_parse, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/index.es6.exports/parse.js
// module id = k4yf
// module chunks = 0 1